@if (isLoading) {
  <div class="grid grid-cols-2 gap-3">
    <vw-skeleton-loader [width]="'100%'" [height]="'150px'" [borderRadius]="'1rem'"></vw-skeleton-loader>
    <vw-skeleton-loader [width]="'100%'" [height]="'150px'" [borderRadius]="'1rem'"></vw-skeleton-loader>
  </div>
} @else if (hasContent) {
  <!-- Deux tuiles, deux destinations. La carte dépliable d'avant demandait un
       geste pour ne rien montrer de plus qu'un thermomètre, puis un second
       geste sur l'une des deux rangées d'action. Ici le premier geste ouvre
       directement la page. -->
  <div class="grid grid-cols-2 gap-3">
    <button
      type="button"
      (click)="openWeather()"
      class="relative flex aspect-square flex-col justify-between overflow-hidden rounded-2xl p-3 text-left shadow-sm transition active:scale-[0.98]"
      [style.background-color]="backgroundColor | HexToHsl"
      [attr.aria-label]="'home.tiles.weather' | translate"
    >
      <span class="text-[10px] font-semibold uppercase tracking-wide text-[#451a03]/60">
        {{ 'home.tiles.weather' | translate }}
      </span>

      <!-- L'illustration au centre : une tuile carrée creuse au milieu se lit
           comme un chargement inachevé. -->
      @if (iconUrl) {
        <div class="flex flex-1 items-center justify-center py-1">
          <vw-icon-svg [iconUrl]="iconUrl" width="52" height="52"></vw-icon-svg>
        </div>
      }

      <div class="min-w-0">
        @if (currentWeather) {
          <p class="text-[28px] font-semibold leading-none text-[#451a03]">
            {{ currentWeather.currentTemperature }}<span class="text-base">°c</span>
          </p>
          <!-- Le mini et le maxi du jour : la valeur du moment ne dit ni si la
               nuit sera froide, ni jusqu'où l'après-midi monte. -->
          <div class="mt-1.5 flex items-center gap-2 text-[11px] text-[#451a03]/80">
            <span class="flex items-center gap-0.5">
              <vw-icon-svg iconUrl="/assets/svg/weather/weather-arrow-up.svg" width="12" height="12"></vw-icon-svg>
              {{ currentWeather.maxTemperature }}°
            </span>
            <span class="flex items-center gap-0.5">
              <vw-icon-svg iconUrl="/assets/svg/weather/weather-arrow-down.svg" width="12" height="12"></vw-icon-svg>
              {{ currentWeather.minTemperature }}°
            </span>
            @if (currentWeather.totalPrecipitation) {
              <span class="flex items-center gap-0.5">
                <vw-icon-svg iconUrl="/assets/svg/weather/weather-droplet.svg" width="12" height="12"></vw-icon-svg>
                {{ currentWeather.totalPrecipitation }}mm
              </span>
            }
          </div>
        }

        <!-- L'alerte du jour : la seule ligne de la tuile qui demande un geste. -->
        @if (weatherTriggers.length) {
          <span
            class="mt-1.5 block w-full truncate rounded-full px-2 py-0.5 text-[10px] font-semibold"
            [style.background-color]="chipStyle(weatherTriggers[0].trigger).background"
            [style.color]="chipStyle(weatherTriggers[0].trigger).ink"
          >
            {{ chipStyle(weatherTriggers[0].trigger).emoji }}
            {{ 'home.garden-today.tags.' + weatherTriggers[0].trigger | translate }}
          </span>
        }
      </div>
    </button>

    <!-- La tuile lunaire, revenue à l'accueil : elle avait disparu derrière un
         dépliement, alors qu'elle porte le jour feuille / racine, qui change
         chaque jour et oriente le geste. -->
    <button
      type="button"
      (click)="openLunar()"
      class="relative flex aspect-square flex-col justify-between overflow-hidden rounded-2xl bg-[#261E77] p-3 text-left shadow-sm transition active:scale-[0.98]"
      [attr.aria-label]="'home.tiles.moon' | translate"
    >
      <span class="text-[10px] font-semibold uppercase tracking-wide text-white/50">
        {{ 'home.tiles.moon' | translate }}
      </span>

      <div class="flex flex-1 items-center justify-center py-1">
        <span class="text-[44px] leading-none">{{ moonGlyph }}</span>
      </div>

      <div class="min-w-0">
        @if (lunar) {
          <p class="text-[17px] font-semibold leading-tight text-white">
            {{ 'home.lunar.influence.' + lunar.influence | translate }}
          </p>
        }
        @if (moonData) {
          <p class="mt-1 truncate text-[11px] text-white/70">
            {{ 'home.weather.moon.phases.' + moonData.moonPhase | translate }}
          </p>
        }
        @if (lunar) {
          <p class="mt-0.5 truncate text-[11px] text-white/70">
            {{ moonPathIcon }} {{ 'home.lunar.moonPath.' + lunar.moonPath | translate }}
          </p>
        }
      </div>
    </button>
  </div>
}
